module.exports = __webpack_public_path__ + "static/vega-burger-9f031d429b47132dd5daeb7c3128afad.jpg";